import React from "react";

export function Mic({
  className = "w-[34px] h-[53px]",
}: {
  className?: string;
}) {
  return (
    <svg
      viewBox="0 0 34 53"
      className={className}
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
    >
      <path
        d="M27 9.9333C27 4.44729 22.5228 0 17 0C11.4772 0 7 4.44729 7 9.9333V27.0667C7 32.5527 11.4772 37 17 37C22.5228 37 27 32.5527 27 27.0667V9.9333Z"
        fill="currentColor"
      />
      <path
        d="M32 24.0122V27.6875C32 35.9568 25.2693 42.6875 17 42.6875C8.73068 42.6875 2 35.9568 2 27.6875V24.0122"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 43V51"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24 51H10"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function Restart() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
    >
      <path
        d="M3.22014 3.2459C5.38407 1.08197 7.97736 0 11 0C14.0226 0 16.6073 1.08197 18.7541 3.2459C20.918 5.39266 22 7.97736 22 11C22 14.0226 20.918 16.6159 18.7541 18.7799C16.6073 20.9266 14.0226 22 11 22V19.4754C13.3528 19.4754 15.3708 18.6339 17.0539 16.9508C18.7369 15.2678 19.5785 13.2498 19.5785 10.897C19.5785 8.52693 18.7369 6.50898 17.0539 4.84309C15.3708 3.16003 13.3528 2.3185 11 2.3185C8.64715 2.3185 6.6292 3.16003 4.94614 4.84309C3.26308 6.50898 2.42155 8.52693 2.42155 10.897C2.42155 12.3396 2.75644 13.6706 3.42623 14.8899C4.11319 16.1093 5.02342 17.1226 6.15691 17.9297L7.80562 16.281C7.90866 16.1952 8.03747 16.1522 8.19204 16.1522C8.36378 16.1522 8.50976 16.2123 8.62998 16.3326C8.75019 16.4356 8.8103 16.5644 8.8103 16.719V21.4333C8.8103 21.8111 8.62139 22 8.24356 22H3.52927C3.37471 22 3.23731 21.9399 3.1171 21.8197C3.01405 21.6995 2.96253 21.5706 2.96253 21.4333C2.96253 21.2959 3.00546 21.1928 3.09133 21.1241L4.40515 19.7845C3.0484 18.7713 1.97502 17.5004 1.18501 15.9719C0.395004 14.4262 0 12.7689 0 11C0 7.97736 1.07338 5.39266 3.22014 3.2459Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function NextIcon({ className = "w-[32px]" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill={"currentColor"}
      className={className}
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m12.631 3.632 8.578 8.577-8.58 8.58-1.062-1.06 6.77-6.77-16.075.004v-1.5l16.076-.004-6.767-6.767z"
      ></path>
    </svg>
  );
}

export function KeyboardIcon() {
  return (
    <svg
      id="Layer_1"
      xmlns="https://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 360 215.6"
    >
      <path
        fill="currentColor"
        d="M30.6.2l296.1-.2c18,1.8,31.9,14.2,33.4,32.6v149.8c-1.9,18-14.1,31.9-32.6,33.3H33.3c-17.5-1.8-31.7-13.9-33.3-31.9V32.6C2,16,13.4,2.2,30.6.2ZM32.8,24.2c-6,1.2-8.3,5.6-8.8,11.4v145.3c.4,7.1,4.9,10.2,11.6,10.9h289.6c7.2-.4,10.3-4.9,10.9-11.6V34.8c-.4-7.1-4.9-10.2-11.6-10.9l-291.6.2Z"
      />
      <rect fill="currentColor" x="96" y="143.7" width="168" height="24" />
      <rect fill="currentColor" x="48" y="47.9" width="24" height="24" />
      <rect fill="currentColor" x="96" y="47.9" width="24" height="24" />
      <rect fill="currentColor" x="144" y="47.9" width="24" height="24" />
      <rect fill="currentColor" x="192" y="47.9" width="24" height="24" />
      <rect fill="currentColor" x="240" y="47.9" width="24" height="24" />
      <rect fill="currentColor" x="288" y="47.9" width="24" height="24" />
      <rect fill="currentColor" x="48" y="95.8" width="24" height="24" />
      <rect fill="currentColor" x="96" y="95.8" width="24" height="24" />
      <rect fill="currentColor" x="144" y="95.8" width="24" height="24" />
      <rect fill="currentColor" x="192" y="95.8" width="24" height="24" />
      <rect fill="currentColor" x="240" y="95.8" width="24" height="24" />
      <rect fill="currentColor" x="288" y="95.8" width="24" height="24" />
      <rect fill="currentColor" x="48" y="143.7" width="24" height="24" />
      <rect fill="currentColor" x="288" y="143.7" width="24" height="24" />
    </svg>
  );
}
